import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AlertClassColour, ApplicationNames, ConfigSystemParams, msSize, OurColors } from 'src/app/core/consts';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, throwError } from 'rxjs';
import { CompletedModalFormComponent } from 'src/app/forms-modal/_pop-ups/completed-modal-form/completed-modal-form.component';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ConfirmationModalFormComponent } from '../../_pop-ups/confirmation-modal-form/confirmation-modal-form.component';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Guid } from 'guid-typescript';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { UserDTO } from 'src/app/core/models/system/user/user.dto';
import { UsersService } from 'src/app/core/services/utelize/system/user/users-service';
import { WarningModalFormComponent } from 'src/app/forms-modal/_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-user-modal-form-more',
  templateUrl: './user-modal-form-more.component.html',
  styleUrls: ['./user-modal-form-more.component.scss']
})

export class UserModalFormMoreComponent implements AfterViewInit, OnDestroy, OnInit {
  
  @Output() moreFormCancelled   : EventEmitter<boolean>=new EventEmitter<boolean>();
  @Output() moreFormHasBeenSaved: EventEmitter<void>   =new EventEmitter<void>();

  @ViewChild('completedModalForm',        { static: false }) completedModalForm!       : CompletedModalFormComponent;
  @ViewChild('killUserConfirmationModal', { static: false }) killUserConfirmationModal!: ConfirmationModalFormComponent;
  @ViewChild('userModalFormMore',         { static: false }) moreFormModal!            : TemplateRef<void>;
  @ViewChild('warningModalForm',          { static: false }) warningModalForm!         : WarningModalFormComponent;

  get isOwnUser       () { return this.sureSimUserID===this.curUser?.userId                      ; }
  get killUserDisabled() { return !this.killUserEnabled || this.isOwnUser                        ; }
  get killUserHint    () { return this.isOwnUser ? "You cannot remove your own user account" : ""; }
    
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }
  
  private initialStatus       : string="Please select an operation";
  private kill_SS_OnlyNewValue: boolean=false;
  private kill_SS_OnlyOldValue: boolean=false;
  private moreFormModalRef!   : NgbModalRef;
  private sureSimUser         : UserDTO | undefined;
  private sureSimUserID       : number | undefined;
   
  public alertColourProgress  : string=AlertClassColour.Green;
  public curUser              : SystemUserDTO;
  public formSubmitted        : boolean=false;
  public highlightBtnKillUser : boolean=false;
  public killUserEnabled      : boolean=false;
  public moreForm!            : UntypedFormGroup;
  public progressInformation  : string=this.initialStatus;
  public submitButtonEnabled  : boolean=false;
  public formTitle            : string="User Operations";

  constructor(
    private authenticationService: AuthenticationService,
    private configSystemService  : ConfigSystemService,
    private exceptionsService    : ExceptionsService,
    private formBuilder          : UntypedFormBuilder,
    private lastPassKillerService: LastPassKillerService,
    private modalService         : NgbModal,
    private usersService         : UsersService
  ) {
      this.curUser=this.authenticationService.currentUserObject();
  }
  
  public ngOnInit(): void {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public resetMainVariables(): void {
    try {
      this.alertColourProgress =AlertClassColour.Green;
      this.formSubmitted       =false;
      this.killUserEnabled     =this.configSystemService.getValueAsBoolean(ConfigSystemParams.KillCompaniesAndUsers, false) &&
                                this.curUser.systemAdmin;
      this.kill_SS_OnlyNewValue=this.configSystemService.getValueAsBoolean(ConfigSystemParams.KillCompaniesAndUsersSureSimOnly, false);
      this.kill_SS_OnlyOldValue=this.kill_SS_OnlyNewValue;
      this.progressInformation =this.initialStatus;
      this.submitButtonEnabled =false;
      this.sureSimUser         =undefined;
      this.sureSimUserID       =undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public openForm(sureSimUserID: number): void {
    try {
      this.resetMainVariables();
      this.setUpForm();
      
      if (sureSimUserID==undefined || <number>sureSimUserID<=0)
        throw new Error("UserModalFormMoreComponent..SureSIM UserID cannot be determined");

      this.sureSimUserID=sureSimUserID;

      this.getSureSimUserAndOpenModal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private openModal(): void {
    try {
      this.moreFormModalRef=this.modalService.open(this.moreFormModal, { backdrop: this.modalBackGround,
                                                                         centered: true,
                                                                         keyboard: false,
                                                                         size    : msSize.Medium });
    }
    catch(e) {
      this.moreFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region moreForm
  
  get formOfMore() {
    return this.moreForm.controls;
  }
    
  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private buildForm() {
    try {
      this.removeFormFields(this.moreForm);
       this.moreForm=this.formBuilder.group({ });
      
      this.addFormFields(this.moreForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.moreForm) {
        this.addFormControl(formGroup, "firstname",       "",    []);
        this.addFormControl(formGroup, "inviewUserId",    "",    []);
        this.addFormControl(formGroup, "killSureSimOnly", false, []);
        this.addFormControl(formGroup, "lastname",        "",    []);
        this.addFormControl(formGroup, "userId",          "",    []);
        this.addFormControl(formGroup, "username",        "",    []);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | string,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private populateFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.moreForm) {
        this.moreForm.controls["firstname"].setValue(this.sureSimUser?.firstname);
        this.moreForm.controls["inviewUserId"].setValue(this.sureSimUser?.inviewUserID);
        this.moreForm.controls["killSureSimOnly"].setValue(this.kill_SS_OnlyOldValue);
        this.moreForm.controls["lastname"].setValue(this.sureSimUser?.lastname);
        this.moreForm.controls["userId"].setValue(this.sureSimUser?.id);
        this.moreForm.controls["username"].setValue(this.sureSimUser?.username);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private enableDisableControls(enabled: boolean) {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public moreFormSubmit() {
    try {
      this.formSubmitted=true;
      
      if (this.moreForm.valid) {
        
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public moreFormCancel() {
    try {
      if (this.kill_SS_OnlyNewValue != this.kill_SS_OnlyOldValue) {
        this.setConfigSystemParamValue(ConfigSystemParams.KillCompaniesAndUsersSureSimOnly, this.kill_SS_OnlyOldValue ? "TRUE" : "FALSE");
      }
      
      this.moreFormCancelled.emit();
      this.moreFormModalRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion
  
  public getSureSimUserAndOpenModal() {
    try {
      this.usersService.getById(<number>this.sureSimUserID)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.sureSimUser=data;
          this.populateFormFields(this.moreForm);
          this.openModal();
        },
        error: error => {
          this.moreFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#region KillUser

  public killUser() {
    try {
      if (this.isOwnUser)
        return;

      this.killUserConfirmationModal.openForm("WARNING", `Are you sure you want to completely remove this user from ${ApplicationNames.SureSIM} and ${ApplicationNames.InviewApi}?`);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public yesKillUser() {
    try {
      if (this.isOwnUser) {
        this.killUserEnabled=false;
        return;
      }

      this.killUserEnabled=false;

      this.usersService.killUser(<Guid>this.sureSimUser?.guid)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.killUserEnabled=false;
    
          if (data.result) {
            this.completedModalForm.openForm("Complete",
                                             "The user has been removed",
                                             "https://cdn.lordicon.com/iuteewri.json",
                                             OurColors.Red,
                                             OurColors.DarkBlue);

          } else {
            this.warningModalForm.openForm("Warning", "The user could not be removed");
          }
        },
        error: error => {
          this.killUserEnabled=false;
    
          this.moreFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public killUserMouseLeave() {
    try {
      this.highlightBtnKillUser=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public killUserMouseOver() {
    try {
      this.highlightBtnKillUser=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public killSureSimOnlyClick() {
    try {
      this.killUserEnabled     =false;
      this.kill_SS_OnlyNewValue=!this.moreForm.get("killSureSimOnly")?.value;

      this.setConfigSystemParamValue(ConfigSystemParams.KillCompaniesAndUsersSureSimOnly, this.kill_SS_OnlyNewValue ? "TRUE" : "FALSE");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region ConfigSystem
  
  public setConfigSystemParamValue(param: string, value: string) {
    try {
      this.configSystemService.setValue(param, value)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.killUserEnabled=true;
        },
        error: error => {
          this.killUserEnabled=true;
          this.moreFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
  
  public completedModalHasBeenClosed() {
    try {
      if (this.kill_SS_OnlyNewValue != this.kill_SS_OnlyOldValue) {
        this.setConfigSystemParamValue(ConfigSystemParams.KillCompaniesAndUsersSureSimOnly, this.kill_SS_OnlyOldValue ? "TRUE" : "FALSE");
      }

      this.moreFormHasBeenSaved.emit();
      this.moreFormModalRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
